export const TierCardBackground = () => {
  return (
    <div
      aria-hidden="true"
      className="absolute inset-y-0 right-0 hidden w-1/2 rounded-lg bg-halfmast-1100/80 shadow-xs sm:block"
    />
  );
};
